import { Controller } from "stimulus";

// Toggles expandable blocks from a button.
// Usage: <div data-controller="simple-collapse"><button data-simple-collapse-target="button" aria-expanded="false"
//   data-action="click->simple-collapse#toggleCollapse">…</button><div class="hidden" data-simple-collapse-target="expandableBlock">…</div></div>
// A button that declares aria-expanded keeps it in sync with the "expanded" class.
export default class extends Controller {
  static targets = ["expandableBlock", "button"]

  toggleCollapse() {
    this.expandableBlockTargets.forEach((block) => {
      block.classList.toggle("hidden")
    })

    const expanded = this.buttonTarget.classList.toggle("expanded")
    if (this.buttonTarget.hasAttribute("aria-expanded")) {
      this.buttonTarget.setAttribute("aria-expanded", String(expanded))
    }
  }
}
